import { Component } from '@angular/core';
import { API_ROUTE } from '@constants/index';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-jne-link',
  standalone: false,
  templateUrl: './jne-link.component.html',
  styleUrls: ['./jne-link.component.scss'],
})
export class JneLinkComponent {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public constructor() {}

  public async showJneInfo(): Promise<void> {
    const fileUrl = (await this.isInternalNetwork())
      ? API_ROUTE.JNE_DOCUMENT.INTERNAL
      : API_ROUTE.JNE_DOCUMENT.EXTERNAL;
    window.open(fileUrl, '_blank');
  }

  // eslint-disable-next-line class-methods-use-this
  public async isInternalNetwork(): Promise<boolean> {
    return environment.production;
  }
}
